import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import { useBackgroundColor } from '@v2/pages/machines/hooks/useBackgroundColor';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { useChangeDisplayModeOnResize } from '@v2/pages/common/hooks/useChangeDisplayModeOnResize';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { useSelector } from 'react-redux';
import { selectIsWithERP } from '@reducers/membership';
import { OperationSearchItem } from '@interfaces/search';
import { LevelSubScreen, Perspective } from '@v2/pages/common/enums';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { JobDetailsScreen } from '@v2/pages/job/common/enums/jobDetails.enum';
import { useCallback } from 'react';
import { MACHINES_MAIN_SCREEN } from '@v2/pages/machines/navigation/config';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { isWeb } from '@helpers';
import { trackEvent, TRACKING_EVENTS } from '@services/tracking';
import { selectSelectedItem } from '@reducers/machines';

const useManageScheduledScreen = () => {
  const navigation = useNavigation<any>();
  const route = useRoute();
  const { detailsWidth, fullWidth } = useDeviceSize();
  const { machineScreenMainBg } = useBackgroundColor();
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();
  const { mode } = useChangeDisplayModeOnResize();
  const { isAllSelected } = useHandleParams();
  const isWithERP = useSelector(selectIsWithERP);
  const selectedItem = useSelector(selectSelectedItem) as Record<string, unknown>;

  const onScheduledJobPress = (job: OperationSearchItem, _: string, levelSubScreen: LevelSubScreen = LevelSubScreen.GENERAL) => {
    trackEvent(TRACKING_EVENTS.MACHINE_SCHEDULED, {
      action: 'jobOpened',
      machineId: selectedItem?.machineId ? String(selectedItem.machineId) : '',
      machineName: (selectedItem?.shortName || selectedItem?.fullName || '') as string,
    });
    navigateToMainDetailsScreen({
      mainScreen: JobDetailsScreenName,
      subScreen: JobDetailsScreen.JOBS,
      levelSubScreen,
      params: {
        perspective: Perspective.JOBS,
        productionOperationId: job.productionOperationId,
        selectedImageKey: job.imageHash,
        documentId: job.imageDocumentId,
      },
    });
  };

  useFocusEffect(
    useCallback(() => {
      if (isWithERP === false) {
        navigation.navigate(`${MACHINES_MAIN_SCREEN}${MachinesScreen.LIVE}`, route?.params ?? {});
      }
    }, [isWithERP, isWeb])
  );

  return {
    detailsWidth,
    fullWidth,
    machineScreenMainBg,
    mode,
    isAllSelected,
    onScheduledJobPress,
  };
};

export { useManageScheduledScreen };
